// Generated by purs version 0.11.7
"use strict";
var Data_Lens_Iso = require("../Data.Lens.Iso");
var Data_Newtype = require("../Data.Newtype");
var _Newtype = function (dictNewtype) {
    return function (dictNewtype1) {
        return function (dictProfunctor) {
            return Data_Lens_Iso.iso(Data_Newtype.unwrap(dictNewtype))(Data_Newtype.wrap(dictNewtype1))(dictProfunctor);
        };
    };
};
module.exports = {
    _Newtype: _Newtype
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Lens.Iso.Newtype/index.js
// module id = 565
// module chunks = 0